import { Mark } from "./Mark";
import { Link, useRouter } from "../router/router";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/airdrop", label: "Airdrop" },
  { to: "/faq", label: "FAQ" },
  { to: "/terms", label: "Terms" },
];

export function Header() {
  const { path } = useRouter();
  return (
    <header className="header">
      <div className="shell header__inner">
        <Link to="/" className="header__mark" aria-label="TISM home">
          <Mark />
          TISM
        </Link>
        <nav className="header__nav" aria-label="Main">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="header__link"
              aria-current={path === item.to ? "page" : undefined}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}
